import { paymentApi } from 'services/http';
import i18n from 'src/i18n';
import * as actionTypes from './actionTypes';
import store from 'src/store/createStore';

import { PAYMENT_STATUS_PAID } from 'services/constants';
import {
  updateAppointment,
  loadAppointmentById,
  updateActiveAppointment
} from 'src/views/practitioner/Appointment/reducers/actions';
import { alertError } from 'services/alerts';
import { loadWorkflowTimeline } from './workflow';
import { requestForHandlePayConfirm } from '../../services/payments';

export const clearInvoice = () => ({
  type: actionTypes.CLEAR_INVOICE
});

export const loadInvoice = (appointmentId, deleteId) => dispatch => {
  onlyLoadInvoice(appointmentId).then(
    data => {
      dispatch(loadInvoiceSuccess(data));
      dispatch(updateActiveAppointment({ invoice: { rowVersion: data.rowVersion } }));
      if (deleteId) {
        dispatch(deleteInvoiceById(data, appointmentId));
      }
    },
    () => {
      dispatch(loadInvoiceError());
    }
  );
};

const loadInvoiceSuccess = data => ({
  type: actionTypes.LOAD_INVOICE_SUCCESS,
  payload: data
});

const loadInvoiceError = () => ({
  type: actionTypes.LOAD_INVOICE_ERROR
});

export const deleteInvoiceById = (invoice, appointmentId) => dispatch => {
  let headers = {
    rowVersion: invoice.rowVersion
  };
  paymentApi
    .delete('invoices/' + invoice.id, { headers })
    .then(() => {
      dispatch(deleteInvoiceSuccess());
      dispatch(loadInvoiceSuccess({}));
      dispatch(loadAppointmentById(appointmentId));
    })
    .catch(err => {
      const errRes = err.response;
      if (errRes && errRes.data && errRes.data.Codes && errRes.data.Codes.length) {
        const codesList = errRes.data.Codes;
        if (codesList.find(el => String(el) === '102')) {
          // invoice was updated we need get new rowVersion
          dispatch(loadInvoice(appointmentId, invoice.id));
        } else if (codesList.find(el => String(el) === '202')) {
          // user was starting paid invoice
          alertError(i18n.t('invoice_in_process_popup_text'));
        } else {
          dispatch(deleteInvoiceError());
        }
      } else {
        dispatch(deleteInvoiceError());
      }
    });
};

export const deleteInvoice = id => dispatch => {
  paymentApi
    .get('' + id)
    .then(() => {
      dispatch(deleteInvoiceSuccess());
    })
    .catch(() => {
      dispatch(deleteInvoiceError());
    });
};

const deleteInvoiceSuccess = () => ({
  type: actionTypes.DELETE_INVOICE_SUCCESS
});

const deleteInvoiceError = () => ({
  type: actionTypes.DELETE_INVOICE_ERROR
});

function onlyLoadInvoice(appointmentId) {
  return new Promise((resolve, reject) => {
    paymentApi
      .get('invoices/' + appointmentId)
      .then(({ data }) => resolve(data))
      .catch(err => reject(err));
  });
}

export const updateInvoiceCertificate = (invoice, certificateNumber) => {
  return new Promise((resolve, reject) => {
    paymentApi
      .put(`invoices/${invoice.id}/certificate`, {
        number: certificateNumber,
        withoutRedux: true
      })
      .then(() => {
        // need deleted!!!
        store.dispatch(
          updateActiveAppointment({
            invoice: { certificateNumber }
          })
        );
        store.dispatch(
          updateAppointment(
            invoice && invoice.externalAppointment && invoice.externalAppointment.externalId,
            {
              invoice: { certificateNumber }
            }
          )
        );
        resolve();
      })
      .catch(err => {
        const { response } = err;
        if (response && response.status === 406) {
          const {
            data: { Codes }
          } = response;
          if (Codes.some(el => String(el) === '204')) {
            reject('error_certificate_number_used');
          } else if (Codes.some(el => String(el) === '202')) {
            reject('error_cant_change_invoice');
          } else {
            alertError();
          }
        } else {
          alertError();
        }
      });
  });
};

// Paid invoice

export const confirmPayment = (invoice, appointmentId, confirmData) => {
  return new Promise((resolve, reject) => {
    const dispatch = store.dispatch;
    requestForHandlePayConfirm(invoice, confirmData).then(
      () => {
        // success
        dispatch(loadWorkflowTimeline(appointmentId));
        dispatch(
          updateAppointment(appointmentId, {
            invoice: { status: PAYMENT_STATUS_PAID, ...confirmData }
          })
        );
        dispatch(confirmPaymentSuccess());
        resolve();
      },
      err => {
        const errRes = err.response;
        if (errRes && errRes.data && errRes.data.Codes && errRes.data.Codes.length) {
          const codesList = errRes.data.Codes;
          dispatch(confirmPaymentError());
          if (codesList.find(el => String(el) === '102')) {
            // invoice was changed
            alertError(i18n.t('toast_payment_changed_reception'));
            reject({
              type: 'invoiceChanged',
              label: 'toast_payment_changed_reception'
            });
          } else if (
            codesList.find(el => String(el) === '202') ||
            codesList.find(el => String(el) === '201')
          ) {
            // user was starting paid invoice
            alertError(i18n.t('invoice_in_process_popup_text'));
          } else if (codesList.find(el => String(el) === '204')) {
            // certificate number was used
            reject({
              type: 'certificateError',
              label: 'error_certificate_number_used'
            });
          }
        } else {
          alertError();
        }
      }
    );
  });
};

const confirmPaymentSuccess = () => ({
  type: actionTypes.CONFIRM_PAYMENT_SUCCESS
});

const confirmPaymentError = () => ({
  type: actionTypes.CONFIRM_PAYMENT_ERROR
});
